import React, { useCallback, useRef } from 'react';
import GeneralCalendar from 'utils/calendar/GeneralCalendar';

const SearchDate = ({ searchMap, updateSearchMap }) => {
  const dateValidEl = useRef(null);
  const dateStatusUpdate = useCallback(value => {
    updateSearchMap("dateValid", dateValidEl.current.checked);
  }, [searchMap.dateValid])

  return (
    <div className="search-condition col-xl-4 col-sm-6">
      <input type="checkbox" ref={dateValidEl} onClick={() => dateStatusUpdate()} />
      <label>날짜</label>
      <GeneralCalendar date={searchMap.beginDate} 
                      updateDateFunction={updateSearchMap}
                      name='beginDate'
                      position={{right: '21', bottom: '-335'}}
                      dateValid={searchMap.dateValid} />
      <span>~</span>
      <GeneralCalendar date={searchMap.endDate} 
                      updateDateFunction={updateSearchMap}
                      name='endDate'
                      position={{right: '-16', bottom: '-335'}}
                      dateValid={searchMap.dateValid} />
    </div>
  )
}

export default React.memo(SearchDate);